import React from 'react';
import PropTypes from 'prop-types';

/**
 * ResponsiveTableContainer
 * * Controla la visibilidad entre la vista de Tarjetas (Móvil) y la Tabla (Escritorio)
 * basándose en la complejidad de la información (Talla).
 * * @param {string} size - Talla de complejidad:
 * - 'S'  (Simple): Cambia en 768px, para 2 a 4 columnas
 * - 'M'  (Estándar): Cambia en 1024px, para 5 a 7 columnas
 * - 'L'  (Grande): Cambia en 1210px, por ejemplo para Listar Productos que tiene 10 columnas
 * - 'XL' (Muy Grande): Cambia en 1280px, para tablas con 11 columnas o más. 

 * @param {React.ReactNode} desktop - El componente <table>
 * @param {React.ReactNode} mobile  - El listado de <div> (cards)
 */
const ResponsiveTableContainer = ({ size = 'M', desktop, mobile }) => {

  // Diccionario de configuración de visibilidad
  const breakpoints = {                                 
    // Talla S: Móvil < 768px | Escritorio >= 768px
    'S': {
      mobile: 'block md:hidden',
      desktop: 'hidden md:block'
    },
    // Talla M: Móvil < 1024px | Escritorio >= 1024px
    'M': {
      mobile: 'block lg:hidden',
      desktop: 'hidden lg:block'
    },
    
    // Talla L (Personalizada): Móvil < 1210px | Escritorio >= 1210px
    'L': {
      mobile: 'block min-[1210px]:hidden',
      desktop: 'hidden min-[1210px]:block'
    },

    // Talla XL: Móvil < 1280px | Escritorio >= 1280px
    'XL': {
      mobile: 'block xl:hidden',
      desktop: 'hidden xl:block'
    }
  };

  // Seleccionamos la configuración o usamos 'M' por defecto
  const config = breakpoints[size] || breakpoints['M'];

  return (
    <>
      {/* VISTA MÓVIL (TARJETAS) */}
      <div className={`mt-4 space-y-3 ${config.mobile}`}>
        {mobile}
      </div>

      {/* VISTA ESCRITORIO (TABLA) */}
      <div className={`mt-4 w-full overflow-x-auto ${config.desktop}`}>
        {desktop}
      </div>
    </>
  );
};

ResponsiveTableContainer.propTypes = {
  size: PropTypes.oneOf(['S', 'M', 'L', 'XL']),
  desktop: PropTypes.node.isRequired,
  mobile: PropTypes.node.isRequired,
};

export default ResponsiveTableContainer;